import {config} from '../config/config';
import {User, Guard} from './';

export default class HowToVideos {
  private url: string = config.armcareServerUrl;
  private user = new User();
  private GUARD = new Guard();
  

  public async GetHowToVideos() {
    const credentials = this.user.GetUserCredentials() as any;
    if (credentials.status) {
      const token = credentials.data.access_token;
      const headers = new Headers({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      });
      try {
        const response = await fetch(`${this.url}/api/v2/video-category`, {
          method: 'GET',
          headers,
        });
        
        this.GUARD.verifyError(response);
        const data = await response.json();
        if (data?.success) {
          return {status: true, data};
        } else {
          return {status: false};
        }
      } catch (e) {
        return {status: false};
      }
    } else {
      return {status: false};
    }    
  }
}
